<template>
	<BaseCmsRotator :fetch="{code: 'homepage_promo', limit: 8, response_fields: ['id','code','link','url_without_domain','link_target_blank','template','image_upload_path']}" :ga4="'home - bestoffers - '" @loadRotatorItems="loadRotatorItems" thumb-preset="promoRotator" v-slot="{items}">
		<div v-if="items?.length" class="hp-promo hp-bg-grey">
			<div class="wrapper">
				<div v-if="labels.get('best_offers') != 'best_offers'" class="hp-promo-header">
					<div class="hp-promo-title hp-title"><BaseCmsLabel code="best_offers" /></div>
					<BasePublishCategory :fetch="{code: ['promotions'], response_fields: ['url_without_domain']}" v-slot="{item}">
						<NuxtLink :to="item?.url_without_domain" class="btn btn-arrow">
							<span><BaseCmsLabel code="show_all" /></span>
						</NuxtLink>
					</BasePublishCategory>
				</div>

				<div class="hp-promo-section">
					<template v-for="(item, index) in items" :key="item.id">
						<NuxtLink
							v-if="item.link"
							:to="item.url_without_domain"
							:target="item.link_target_blank == 1 ? '_blank' : null"
							@click="gtm.gtmPromoClick(item.title, 'home - bestoffers - ', index, item.code, item.template)"
							class="hp-promo-item hp-promo-item-link"
							:class="{'hp-promo-item-big': item.template == 'template_hp_promo_big', 'hp-promo-item-medium': item.template == 'template_hp_promo_medium'}">
							<span v-if="item.image_upload_path">
								<BaseUiImage loading="lazy" :data="item.template == 'template_hp_promo_big' ? item.image_upload_path_thumb_big : item.image_upload_path_thumb" />
							</span>
						</NuxtLink>
						<div v-else class="hp-promo-item" :class="{'hp-promo-item-big': item.template == 'template_hp_promo_big', 'hp-promo-item-medium': item.template == 'template_hp_promo_medium'}">
							<span v-if="item.image_upload_path">
								<BaseUiImage :data="item.template == 'template_hp_promo_big' ? item.image_upload_path_thumb_big : item.image_upload_path_thumb" />
							</span>
						</div>
					</template>
				</div>
			</div>
		</div>
	</BaseCmsRotator>
</template>

<script setup>
	const labels = useLabels();
	const gtm = useGtmBB();

	//gtm
	function loadRotatorItems(value) {
		if (value?.items?.length) {
			value?.items.forEach((item, index) => {
				let template = ''
				if(item?.template == 'template_hp_promo_big') {
					template = 'big - ';
				} else if(item?.template == 'template_hp_promo_medium') {
					template = 'medium - ';
				}
				gtm.viewPromotion({
					creative_name: item.title || '',
					creative_slot: value.creativeSlot + template + (index + 1),
					promotion_id: item.code || '',
					promotion_name: item.title || '',
				});
			});
		}
	}
</script>

<style lang="less" scoped>
	.hp-promo {
		padding: 70px 0 75px;

		@media (max-width: @t) {
			padding: 35px 0 30px;
		}
		@media (max-width: @m) {
			padding: 30px 0;
		}
		@media (max-width: @ms) {
			padding: 30px 0 20px;
		}
	}
	.hp-promo-header {
		display: flex;
		align-items: baseline;
		margin-bottom: 20px;

		@media (max-width: @t) {
			margin-bottom: 15px;
		}
		@media (max-width: @m) {
			margin-bottom: 10px;
		}
		@media (max-width: @ms) {
			margin-bottom: 15px;
		}
	}
	.hp-promo-section {
		display: flex;
		flex-wrap: wrap;
		width: calc(~'100% - -20px');
		margin-left: -10px;

		@media (max-width: @t) {
			width: calc(~'100% - -12px');
			margin-left: -6px;
		}
		@media (max-width: @m) {
			width: calc(~'100% - -12px');
			margin-left: -6px;
		}
		@media (max-width: @ms) {
			width: 100%;
			margin-left: 0;
		}
	}
	.hp-promo-item {
		margin: 10px;
		:deep(span) {
			display: block;
		}
		:deep(img) {
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
			display: block;
			align-self: flex-start;
			.transition(box-shadow);
		}

		@media (max-width: @t) {
			margin: 6px;
		}
		@media (max-width: @ms) {
			margin: 0 0 15px;
			:deep(span) {
				display: flex;
				justify-content: center;
			}
		}
	}
	@media (min-width: @t) {
		.hp-promo-item-link:hover :deep(img) {
			box-shadow: 0 15px 30px 0 rgba(0, 46, 86, 0.3);
		}
	}
	.hp-promo-item-big {
		width: calc(~'50% - 20px');

		@media (max-width: @t) {
			width: calc(~'50% - 12px');
		}
		@media (max-width: @ms) {
			width: 100%;
		}
	}
	.hp-promo-item-medium {
		width: calc(~'33.333% - 20px');

		@media (max-width: @t) {
			width: calc(~'33.333% - 12px');
		}
		@media (max-width: @ms) {
			width: 100%;
		}
	}
</style>
